// redux
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { logout } from '../../../store/slices/usuario';
// mui components
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// mui icons
import MenuIcon from '@mui/icons-material/Menu';
// componentes propios
import Usuarios from './Usuarios';
import MenuEdicion from '../../Appbar/MenuEdicion';

const drawerWidth = 240;

type Props = {
    handleDrawerToggle: Function
    titulo: String
}

const Appbar = ({ handleDrawerToggle, titulo }: Props) => {

    const dispatch = useDispatch<AppDispatch>();

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar
                position="fixed"
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
                style={{
                    boxShadow: "0px 0px 0px 0 rgba(0, 0, 0, 0)",
                    background: 'white',
                    color: 'black'
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={() => handleDrawerToggle()}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>

                    <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                        {titulo}
                    </Typography>

                    <Usuarios />

                    <MenuEdicion />

                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default Appbar